import * as React from 'react';
import { ArticleHeading2, UIText1 } from '@cian/ui-kit';

import { NBSP } from '../../../../../../../../../constants/symbols';

import * as styles from './ServicePrice.css';

interface IProps {
  price: string;
}

export const ServicePrice = ({ price }: IProps) => (
  <div className={styles['price']}>
    <ArticleHeading2>{price}</ArticleHeading2>
    {NBSP}
    <UIText1>₽/день</UIText1>
  </div>
);
